'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = connectReducer;

var _lodash = require('lodash.mergewith');

var _lodash2 = _interopRequireDefault(_lodash);

var _helpers = require('../helpers');

var _actions = require('../actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TPT_CONNECT_TYPES = [_actions.TPT_CONNECT_INVALIDATE, _actions.TPT_CONNECT_PREPOPULATE, _actions.TPT_CONNECT_REQUEST, _actions.TPT_CONNECT_SUCCESS, _actions.TPT_CONNECT_FAILURE];

function connectReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = arguments[1];
  var type = _ref.type,
      error = _ref.error,
      payload = _ref.payload;

  if (!~TPT_CONNECT_TYPES.indexOf(type)) {
    return state;
  }

  var fetchesCount = state.fetchesCount || 0;

  if (error && type !== _actions.TPT_CONNECT_FAILURE) {
    // internal error
    fetchesCount--;
    _helpers.logger.error(payload);
  } else if (type === _actions.TPT_CONNECT_FAILURE || type === _actions.TPT_CONNECT_SUCCESS) {
    fetchesCount--;
  } else if (type === _actions.TPT_CONNECT_PREPOPULATE) {
    fetchesCount++;
  }

  var updateStrategy = payload.updateStrategy;

  delete payload.updateStrategy;

  var newState = _extends({}, state, {
    fetchesCount: fetchesCount,
    isAllFetched: fetchesCount === 0,
    // If the fetch itself fails, e.g. due to timeout, "payload" is actually an error.
    // Otherwise, if json parsing failed, the error is stored in payload.error
    error: error ? payload.error || payload : false
  });

  // we don't want to change any of the resources if updateStrategy is false
  if (!updateStrategy || updateStrategy === 'success' && payload.error) {
    return newState;
  }

  return (0, _lodash2.default)({}, newState, payload, function (oldValue, newValue) {
    // custom merger to handle arrays
    if (Array.isArray(oldValue) && Array.isArray(newValue)) {
      if (updateStrategy === 'append') {
        // TODO: concat only uniques?
        newValue = oldValue.concat(newValue);
      } else if (updateStrategy === 'prepend') {
        newValue = newValue.concat(oldValue);
      } else if (updateStrategy === 'remove') {
        newValue = oldValue.filter(function (id) {
          return !newValue.includes(id);
        });
      } else if (typeof updateStrategy === 'function') {
        newValue = updateStrategy(newValue, oldValue);
      }
      return newValue;
    }
  });
}
module.exports = exports['default'];